module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-main-url"
  }, [(_vm.mainBlockIsHearing) ? _c('p', {
    staticClass: "block-main-url"
  }, [_vm._v("\n      " + _vm._s(_vm.hearing.CommitteeName) + " " + _vm._s(_vm.textHasHearingInCase) + ": "), _c('a', {
    attrs: {
      "href": _vm.hearing.ProceedingLinkUrl,
      "title": _vm.hearing.ProceedingTitle
    }
  }, [_vm._v(_vm._s(_vm.hearing.ProceedingTitle))])]) : _c('p', {
    staticClass: "block-main-url"
  }, [_vm._v("\n      " + _vm._s(_vm.textCaseNr) + " " + _vm._s(_vm.agenda.OrderNumber) + ": "), _c('a', {
    attrs: {
      "href": _vm.agenda.LinkUrl,
      "title": _vm.agenda.TitleText
    }
  }, [_vm._v(_vm._s(_vm.agenda.TitleText))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c47bbcd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Top/TopTextBoxMainUrl.vue
// module id = 104
// module chunks = 1